<template>
  <div class="DetailComment">
    <div class="comment-main">
      <div class="comment-title">{{ $t('commentTitle') }}</div>
      <div class="comment-input-disabled" v-if="house.disableComment && enableComment">
        {{ $t('hasQuestioned') }}
      </div>
      <div class="comment-input" v-else>
        <input
          class="comment-input-item"
          :class="{ 'input-submitting': isSubmitting }"
          type="text"
          title="comment-input"
          :placeholder="$t('commentPlace')"
          v-model="inputWords"
          :disabled="isSubmitting"
        />
        <span class="comment-input-submit" :class="{ 'submit-loading': isSubmitting }" @click="submitComment">
          <i class="iconfont loading" v-if="isSubmitting"></i>
          {{ $t('commentBtn') }}
        </span>
      </div>
      <div class="comment-list">
        <div class="comment-item" v-for="(commentItem, commentIndex) in showList" :key="'comment-' + commentIndex">
          <div class="comment-question">Q: {{ commentItem.comment }}</div>
          <div class="comment-answer" v-if="commentItem.reply">
            <div
              class="comment-answer-avatar"
              v-lazy:background-image="commentItem.reply.avatar.url"
              v-if="commentItem.reply.avatar.url"
            ></div>
            <div class="comment-answer-content">
              <div class="comment-answer-content-info">
                {{ commentItem.reply.nickname }} -
                {{ getTimeStr(commentItem.reply.createdAt) }}
              </div>
              <div>{{ commentItem.reply.comment }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="comment-view-all" v-if="commentList.length >= 2" @click="showListFun">
        <span>{{ $t('viewAllQA', { num: commentList.length }) }}</span>
        <i class="iconfont" :class="[showAllList ? 'up' : 'down']"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailComment',
  props: {
    isSell: {
      type: Boolean,
      default() {
        return false
      },
    },
    houseID: {
      type: String,
      default() {
        return ''
      },
    },
    house: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      inputWords: '',
      commentList: [], //评论列表（所有）
      showAllList: false, //是否展开列表
      isSubmitting: false, //提交状态
      enableComment: true, //允许评论
    }
  },
  computed: {
    showList() {
      if (this.showAllList) {
        return this.commentList
      } else {
        return this.commentList.slice(0, 1)
      }
    },
  },
  methods: {
    showListFun() {
      this.showAllList = !this.showAllList
    },
    getCommentData() {
      let _this = this
      let data = {
        type: this.isSell ? 'sell' : 'rental',
        id: this.houseID,
      }

      this.$axios({
        url: '/api/v1/client/estate/getComment?type=' + data.type + '&id=' + data.id,
        method: 'get',
      }).then(res => {
        if (res.docs) {
          _this.commentList = res.docs
        }
      })
    },
    submitComment() {
      let _this = this
      if (!this.inputWords.length) {
        return 0
      }
      _this.isSubmitting = true
      let detailType = this.isSell ? 'sell' : 'rental'
      let data = {
        id: this.houseID,
        comment: this.inputWords,
        device: navigator.userAgent,
      }
      this.$axios({
        url: '/api/v1/client/estate/' + detailType + '/addComment',
        method: 'post',
        data: data,
      })
        .then(res => {
          if (res.ok) {
            _this.inputWords = ''
            _this.isSubmitting = false
            _this.getCommentData()
          } else {
            _this.isSubmitting = false
            _this.enableComment = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getTimeStr(timeStr) {
      let date = new Date(timeStr)
      return (
        date.getFullYear() +
        '.' +
        (date.getMonth() + 1) +
        '.' +
        date.getDate() +
        ' ' +
        date.getHours() +
        ':' +
        date.getMinutes() +
        ':' +
        date.getSeconds()
      )
    },
  },
  watch: {
    houseID() {
      this.getCommentData()
    },
  },
}
</script>

<style scoped lang="less">
.DetailComment {
  margin-top: 30px;
  width: 100%;

  input {
    border: none;
  }

  .comment-main {
    margin: 0;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.06);
    border-radius: 8px;

    .comment-title {
      padding: 16px 22px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
    }

    .comment-input {
      margin: 0 22px;
      display: flex;
      height: 46px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(153, 210, 13, 1);

      .comment-input-item {
        margin: 0;
        padding: 0;
        width: 75%;
        height: 46px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 46px;
        text-indent: 10px;
        border-radius: 4px;
        outline: none;
      }

      .input-submitting {
        color: rgba(0, 0, 0, 0.25);
        background-color: rgba(246, 246, 246, 1);
      }

      .comment-input-submit {
        display: inline-block;
        width: 25%;
        height: 46px;
        background: rgba(153, 210, 13, 1);
        border-radius: 0 4px 4px 0;
        font-size: 12px;
        color: rgba(255, 255, 255, 1);
        line-height: 46px;
        text-align: center;
        cursor: pointer;
      }

      .submit-loading {
        background: rgba(135, 180, 22, 1);

        .iconfont {
          font-size: 22px;
          vertical-align: middle;
        }

        span {
          vertical-align: middle;
        }
      }
    }

    .comment-input-disabled {
      margin: 0 22px;
      padding-left: 20px;
      display: flex;
      height: 46px;
      background: rgba(246, 246, 246, 1);
      box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      border: 1px solid rgba(153, 210, 13, 1);
      color: rgba(0, 0, 0, 0.25);
      font-size: 12px;
      line-height: 46px;
    }
  }

  .comment-list {
    margin: 30px auto 0;
    padding-bottom: 15px;
    max-height: 500px;
    overflow-y: auto;

    .comment-item {
      padding: 15px 22px 0;

      .comment-question {
        padding-bottom: 15px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
      }

      .comment-answer {
        .comment-answer-avatar {
          display: inline-block;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          vertical-align: top;
          background: rgba(0, 0, 0, 0.1) no-repeat center center;
          background-size: cover;
        }

        .comment-answer-avatar[lazy='loading'] {
          background: rgba(0, 0, 0, 0.1) no-repeat center center;
          background-size: cover;
        }

        .comment-answer-content {
          display: inline-block;
          padding-left: 12px;
          width: 465px;
          font-size: 12px;
          line-height: 17px;
          color: rgba(0, 0, 0, 0.85);

          .comment-answer-content-info {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 17px;
          }
        }
      }
    }
  }

  .comment-view-all {
    padding: 10px 0 15px 0;
    font-size: 12px;
    width: 100%;
    color: rgba(158, 207, 64, 1);
    text-align: center;
    cursor: pointer;

    span {
      padding-right: 5px;
    }

    .iconfont {
      font-size: 16px;
      vertical-align: middle;
    }
  }
}
</style>
